/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  storeLocator: {
    name: 'storeLocator',
    componentName: 'StoreLocatorContainer',
    chunk: () => import(
      /* webpackChunkName: "store-locator" */
      './pages/store-locator/StoreLocatorContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/store-locator/StoreLocatorContainer.js')).StoreLocatorContainer
        : currentRouteName === 'storeLocator'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.StoreLocatorContainer }))
          );
    },
    path: '/:context?/l/store-locator',
    varnish: true,
    channel: 'desktop'
  },

  storeLocatorMobile: {
    name: 'storeLocatorMobile',
    componentName: 'StoreLocatorMobileContainer',
    chunk: () => import(
      /* webpackChunkName: "store-locator-mobile" */
      './pages/store-locator/StoreLocatorMobileContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/store-locator/StoreLocatorMobileContainer.js')).StoreLocatorMobileContainer
        : currentRouteName === 'storeLocatorMobile'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.StoreLocatorMobileContainer }))
          );
    },
    path: '/:context?/l/store-locator',
    varnish: true,
    channel: 'mobile'
  },

  homeServices: {
    name: 'homeServices',
    componentName: 'HomeServicesContainer',
    chunk: () => import(
      /* webpackChunkName: "homeservices" */
      './pages/home-services/HomeServicesContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/home-services/HomeServicesContainer.js')).HomeServicesContainer
        : currentRouteName === 'homeServices'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.HomeServicesContainer })))
    },
    path: '/:context?/l/:name/:state/:city/:storeZip/:storeNumber/services',
    varnish: true,
    channel: null
  },

  rentalServices: {
    name: 'rentalServices',
    componentName: 'RentalServicesContainer',
    chunk: () => import(
      /* webpackChunkName: "rentalservices" */
      './pages/rental-services/RentalServicesContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/rental-services/RentalServicesContainer.js')).RentalServicesContainer
        : currentRouteName === 'rentalServices'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.RentalServicesContainer })))
    },
    path: '/:context?/l/:name/:state/:city/:storeZip/:storeNumber/rentals',
    varnish: true,
    channel: null
  },

  gardenCenter: {
    name: 'gardenCenter',
    componentName: 'GardenCenterContainer',
    chunk: () => import(
      /* webpackChunkName: "gardencenter" */
      './pages/garden-center/GardenCenterContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/garden-center/GardenCenterContainer.js')).GardenCenterContainer
        : currentRouteName === 'gardenCenter'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.GardenCenterContainer })))
    },
    path: '/:context?/l/:name/:state/:city/:storeZip/:storeNumber/garden-center',
    varnish: true,
    channel: null
  },

  proDesk: {
    name: 'proDesk',
    componentName: 'ProDeskContainer',
    chunk: () => import(
      /* webpackChunkName: "proDesk" */
      './pages/pro-desk/ProDeskContainer'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/pro-desk/ProDeskContainer.js')).ProDeskContainer
        : currentRouteName === 'proDesk'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ProDeskContainer })))
    },
    path: '/:context?/l/:name/:state/:city/:storeZip/:storeNumber/pro-desk',
    varnish: true,
    channel: null
  },

  storeReviews: {
    name: 'storeReviews',
    componentName: 'ReviewsContainer',
    chunk: () => import(
      /* webpackChunkName: "store-reviews" */
      './pages/store-reviews/ReviewsContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/store-reviews/ReviewsContainer.js')).ReviewsContainer
        : currentRouteName === 'sstoreReviews'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ReviewsContainer })))
    },
    path: '/:context?/l/:name/:state/:city/:storeZip/:storeNumber/reviews/:reviewPage?',
    varnish: true,
    channel: null
  },

  storeDetails: {
    name: 'storeDetails',
    componentName: 'DetailsContainer',
    chunk: () => import(
      /* webpackChunkName: "store-details" */
      './pages/store-details/DetailsContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/store-details/DetailsContainer.js')).DetailsContainer
        : currentRouteName === 'storeDetails'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.DetailsContainer })))
    },
    path: '/:context?/l/:name/:state/:city/:storeZip/:storeNumber',
    varnish: true,
    channel: null
  },

  storeDirectory: {
    name: 'storeDirectory',
    componentName: 'DirectoryContainer',
    chunk: () => import(
      /* webpackChunkName: "store-directory" */
      './pages/store-directory/DirectoryContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/store-directory/DirectoryContainer.js')).DirectoryContainer
        : currentRouteName === 'storeDirectory'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.DirectoryContainer })))
    },
    path: '/:context?/l/storeDirectory',
    varnish: true,
    channel: null
  },

  localCity: {
    name: 'localCity',
    componentName: 'LocalCityContainer',
    chunk: () => import(
      /* webpackChunkName: "local-city" */
      './pages/local-city/LocalCityContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/local-city/LocalCityContainer.js')).LocalCityContainer
        : currentRouteName === 'localCity'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.LocalCityContainer })))
    },
    path: '/:context?/l/:state/:city/:guid',
    varnish: true,
    channel: null
  },

  stateDirectory: {
    name: 'stateDirectory',
    componentName: 'StateDirectoryContainer',
    chunk: () => import(
      /* webpackChunkName: "state-directory" */
      './pages/store-directory/StateDirectoryContainer'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/store-directory/StateDirectoryContainer.js')).StateDirectoryContainer
        : currentRouteName === 'stateDirectory'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.StateDirectoryContainer })))
    },
    path: '/:context?/l/:state',
    varnish: true,
    channel: null
  },
});
